module.exports = __webpack_public_path__ + "static/media/emaileditor.56bccf55.svg";